export enum Operator {
    // EQ, NE, GT, GE, LT, LE, LIKE
    EQ = 'is',
    NE = 'is not',
    GT = 'great than',
    GE = 'great than or is equals to',
    LT = 'less than',
    LE = 'less than or is equals to',
    LIKE = 'contains',
}